








































































































import Loader from '@/components/Loader.vue';
import TextField from '@/components/TextField.vue';
import axios from 'axios';
import Vue from 'vue';

interface Data {
  shareRecipient: string;
  recipientError: string | undefined;
  loadingShare: boolean;
}

export default Vue.extend({
  name: 'Navbar',
  components: {
    TextField,
    Loader,
  },
  computed: {
    getUrl(): string {
      return window.location.origin;
    },
    windowWidth(): number {
      return window.innerWidth;
    },
  },
  data(): Data {
    return {
      shareRecipient: '',
      recipientError: undefined,
      loadingShare: false,
    };
  },
  methods: {
    canShare() {
      const canShare = (navigator as any).share !== undefined;
      return canShare;
    },
    showShare() {
      this.$modal.show('share');
    },
    hideShare() {
      this.$modal.hide('share');
    },
    async share() {
      const shareData = {
        title: 'UFCW Scholarship',
        text: 'Sign up for the UFCW Scholarship program',
        url: window.location.origin,
      };

      try {
        await (navigator as any).share(shareData);
      } catch (e) {
        console.error(e);
      }
    },
    async shareSmsOrEmail() {
      const send = async (recipient: string) => {
        this.loadingShare = true;
        return await axios
          .post(`${process.env.VUE_APP_API_URI}/api/application/share`, {
            recipient,
          })
          .then(res => {
            Vue.toasted.success(`Shared to ${this.shareRecipient}`, {
              duration: 5000,
            });

            this.shareRecipient = '';
            this.loadingShare = false;
          })
          .catch(e => {
            console.error(e);
            Vue.toasted.error(
              `Something went wrong sharing to ${this.shareRecipient}`
            );

            this.loadingShare = false;
          });
      };

      this.recipientError = undefined;

      if (!this.shareRecipient) {
        this.recipientError = 'Invalid recipient';
      } else if (this.shareRecipient.includes('@')) {
        send(this.shareRecipient);
      } else {
        const num = this.shareRecipient.replace(/[^\d]/, '');

        if (num.length < 10) {
          this.recipientError = 'Invalid phone number';
          return;
        }

        send(num);
      }
    },
    async copyLink() {
      const success = () => {
        Vue.toasted.success('Link copied to clipboard', {
          duration: 3000,
        });
      };
      try {
        if (navigator.clipboard) {
          await navigator.clipboard.writeText(this.getUrl);
          success();
        } else {
          const input = document.createElement('input');
          input.value = this.getUrl;
          document.body.appendChild(input);
          input.select();
          document.execCommand('copy');
          document.body.removeChild(input);
          success();
        }
      } catch (e) {
        Vue.toasted.error(
          "Failed to copy link to clipboard. Try copying from your browser's search box.",
          {
            duration: 5000,
          }
        );
      }
    },
  },
  watch: {
    shareRecipient() {
      this.recipientError = undefined;
    },
  },
});
